export const MenuItems = [
  {
    id: "1",
    name: "Home",
    href: "/",
  },
  {
    id: "2",
    name: "About Us",
    href: "#",
    submenu: [
      { id: "2-1", name: "Vision", href: "#" },
      { id: "2-2", name: "Infrastructure", href: "#" },
      { id: "2-3", name: "CSR", href: "#" },
      { id: "2-4", name: "Board Report MGT7 22-2023", href: "#" },
      { id: "2-5", name: "Board Report MGT7 23-2024", href: "#" },
    ],
  },
  {
    id: "3",
    name: "Products",
    href: "#",
  },
  {
    id: "4",
    name: "Certificates",
    href: "#",
  },
  {
    id: "5",
    name: "Contact Us",
    href: "#",
  },
  {
    id: "6",
    name: "Career",
    href: "#",
  },
];


export const DropdownItems = [
  {
    id: "1",
    name: "Clients",
    href: "#",
  },
  {
    id: "2",
    name: "Gallery",
    href: "#",
  },
  {
    id: "3",
    name: "Media & PR",
    href: "#",
  },
  {
    id: "4",
    name: "Events",
    href: "#",
  },
];

